import { lazy, ReactNode, Suspense } from 'react'

const LocalizationProvider = lazy(async () => {
    const [localization, adapter] = await Promise.all([
        import('@mui/x-date-pickers/LocalizationProvider'),
        import('@mui/x-date-pickers/AdapterDayjs'),
    ])

    return {
        default: ({ children }: { children: ReactNode }) => (
            <localization.LocalizationProvider
                dateAdapter={adapter.AdapterDayjs}
                localeText={{
                    fieldHoursPlaceholder: () => '--',
                    fieldMinutesPlaceholder: () => '--',
                    fieldMeridiemPlaceholder: () => '',
                }}
            >
                {children}
            </localization.LocalizationProvider>
        ),
    }
})

const DatePickerProvider = ({ children }: { children: ReactNode }) => (
    <Suspense fallback={null}>
        <LocalizationProvider>{children}</LocalizationProvider>
    </Suspense>
)

export default DatePickerProvider
